import { atom } from 'jotai';

export interface IHomepageMaterial {
  videoUrl: string;
  posterUrl: string;
}

export const $HomepageMaterial = atom<IHomepageMaterial>({
  videoUrl: '',
  posterUrl: '',
});

$HomepageMaterial.debugLabel = '$HomepageMaterial';
